///////////////////
// My Barbershop Drawer
//////////////////

async function barbershopDrawer() {
  const buttons = document.querySelectorAll('[data-barbershop-drawer]');
  const barbershopDrawer = document.getElementById('barbershop-drawer');
  if (!barbershopDrawer) {
    console.warn('Barbershop drawer not found');
    return;
  } else {
    // console.log('Barbershop drawer found', barbershopDrawer);
  }

  if (barbershopDrawer.getAttribute('data-barbershop-id')) {
    // Appends drawer nav to body (once) before open, to avoid z-index issues with overlay and header.
    if (barbershopDrawer.parentElement !== document.body) {
      document.body.appendChild(barbershopDrawer);
    }
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      // console.log('Opening barbershop drawer');
      barbershopDrawer.open(button);
    });
  });

  barbershopDrawer.addEventListener('on:barbershop-drawer:before-open', async (event) => {
    // console.log('Drawer before-open event triggered');
    const shortcutsId = barbershopDrawer.getAttribute('data-barbershop-id');
    // console.log('Shortcuts ID:', shortcutsId);
    if (shortcutsId) {
      // console.log('Dispatching shop-data event');
      // Wait for next frame to ensure drawer content is rendered
      requestAnimationFrame(() => {
        const barbershopInfo = barbershopDrawer.querySelector('.barbershop-info');
        if (barbershopInfo) {
          document.dispatchEvent(
            new CustomEvent('dispatch:shop-data', {
              detail: {
                hours: false,
                waitTimes: true,
                wrapper: barbershopInfo,
                filter: shortcutsId
              },
            })
          );
        } else {
          console.warn('Could not find .barbershop-info element in drawer');
        }
      });
    }
  });

  barbershopDrawer.addEventListener('on:barbershop-drawer:after-open', (event) => {
    // console.log('Drawer after-open event triggered');
  });

  barbershopDrawer.addEventListener('on:barbershop-drawer:after-close', (event) => {
    // console.log('Drawer after-close event triggered');
  });

  initBarbershopSwiper();
}

function initBarbershopSwiper() {
  const swiperElement = document.getElementById('swiper-barbershop-drawer');
  if (!swiperElement) {
    return;
  }

  try {
    new Swiper('#swiper-barbershop-drawer', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      spaceBetween: 10,
      navigation: false,
      slidesPerView: 1.5,
      breakpoints: {
        991: {
          slidesPerView: 1.25,
          spaceBetween: 10,
        },
      },
    });
  } catch (error) {
    console.error('Failed to initialize barbershop Swiper:', error);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  barbershopDrawer();
});

document.addEventListener('favorite-store:change', (event) => {
  // Check if the favorite button was clicked inside the barbershop drawer
  const barbershopDrawer = document.getElementById('barbershop-drawer');
  if (barbershopDrawer && barbershopDrawer.open) {
    barbershopDrawer.close();
  }

  // Show placeholder animation on ALL barbershop buttons (desktop and mobile)
  const headerButtons = document.querySelectorAll('.barbershop-button');
  headerButtons.forEach(headerButton => {
    const desktopContent = headerButton.querySelector('.content');
    if (desktopContent) {
      // Add loading class to trigger fade out (following store-wait-time.js pattern)
      desktopContent.classList.add('loading-location');

      // Listen for the fade out transition to complete
      const handleTransitionEnd = () => {
        // Remove the event listener
        desktopContent.removeEventListener('transitionend', handleTransitionEnd);

        // The header will be re-rendered by the system
        // We don't need to manually remove the loading class as the element will be replaced
      };

      // Add the transition end listener
      desktopContent.addEventListener('transitionend', handleTransitionEnd);
    }
  });
});

document.addEventListener('barbershop-drawer:after:rendered', () => {
  document.querySelector('.js-overlay').classList.remove('is-visible');
  barbershopDrawer();
});